import {BitacoraTiposEnum, obtenerIdBitacoraTipo} from "@shared/enums";
import {Nilable} from "@shared/utils";
import {DTO, IDTO} from "./dto";

export interface IBitacoraDTO extends IDTO {
    date_created?: Nilable<string>;
    description: string;
    date: string;
    type: string;
    user?: Nilable<number>;
}

export class BitacoraDTO implements DTO {
    public fechaCreada: Nilable<Date> = null;
    public descripcion = "";
    public fecha = new Date();
    public tipo: BitacoraTiposEnum = BitacoraTiposEnum.REQUEST;
    public usuario: Nilable<number> = null;

    constructor(json?: Nilable<Partial<IBitacoraDTO>>) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IBitacoraDTO>): void {
        if (json.date_created != null) {
            this.fechaCreada = new Date(json.date_created);
        }
        if (json.description != null) {
            this.descripcion = json.description;
        }
        if (json.date != null) {
            const splitFecha = json.date.split("-").map(Number);
            this.fecha = new Date();
            this.fecha.setFullYear(splitFecha[0]);
            this.fecha.setMonth(splitFecha[1] - 1);
            this.fecha.setDate(splitFecha[2]);
        }
        if (json.type != null) {
            this.tipo = BitacoraTiposEnum[json.type];
        }
        if (json.user != null) {
            this.usuario = json.user;
        }
    }

    public toJSON(): IBitacoraDTO {
        const json: IBitacoraDTO = {
            description: this.descripcion,
            date: `${this.fecha.getFullYear()}-${this.fecha.getMonth() + 1}-${this.fecha.getDate()}`,
            type: obtenerIdBitacoraTipo(this.tipo)
        };
        if (this.fechaCreada != null) {
            json.date_created = this.fechaCreada.toJSON();
        }
        if (this.usuario != null) {
            json.user = this.usuario;
        }
        return json;
    }
}
